import { Data } from '@blade/std-lib'

import type { Lang } from '@root/shared/localization'

export class ChangeLanguageStateDone extends Data.TaggedClass(
  'ChangeLanguageStateDone',
) {}

export class ChangeLanguageStateLoading extends Data.TaggedClass(
  'ChangeLanguageStateLoading',
)<{
  lang: Lang.Lang
}> {}

export type ChangeLanguageState =
  | ChangeLanguageStateDone
  | ChangeLanguageStateLoading

export const match = Data.matchFor<ChangeLanguageState>()
